import { ThirdPartySystemId } from "./third-party-system.enums";

export const GenericThirdPartySystemId = ThirdPartySystemId.GENERIC;

export const TransactionDetailsTypeId = {
    GENERIC: 0,
    DEALERTRACK_PARTS: 101,
    DEALERTRACK_SERVICE: 102,
    DEALERTRACK_DEAL: 103,
    DEALERTRACK_LEASING: 104,
    DEALERTRACK_AR_STATEMENT_CUSTOMERS: 105,
} as const;

export type TransactionDetailsTypeId =
    (typeof TransactionDetailsTypeId)[keyof typeof TransactionDetailsTypeId];

export const TransactionDetailsTypeIdToName: Record<TransactionDetailsTypeId, string> = {
    [TransactionDetailsTypeId.GENERIC]: 'GENERIC',
    [TransactionDetailsTypeId.DEALERTRACK_PARTS]: 'DEALERTRACK_PARTS',
    [TransactionDetailsTypeId.DEALERTRACK_SERVICE]: 'DEALERTRACK_SERVICE',
    [TransactionDetailsTypeId.DEALERTRACK_DEAL]: 'DEALERTRACK_DEAL',
    [TransactionDetailsTypeId.DEALERTRACK_LEASING]: 'DEALERTRACK_LEASING',
    [TransactionDetailsTypeId.DEALERTRACK_AR_STATEMENT_CUSTOMERS]:
        'DEALERTRACK_AR_STATEMENT_CUSTOMERS',
} as const;
